import styled from 'styled-components';

const StyledHeader = styled.header`
  height: 82px;
  min-height: 82px;
  background-color: ${({ theme }) => theme.colors.mainColorContrast};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const TitleVersionContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Title = styled.h1`
  ${({ theme }) => theme.typograph.titleRegular};
  color: ${({ theme }) => theme.colors.backgroundColorWhite};
  text-transform: uppercase;
  margin-right: 16px;
`;

const Version = styled.p`
  ${({ theme }) => theme.typograph.descriptionLight};
  color: ${({ theme }) => theme.colors.backgroundColorWhite};
  margin-top: 2px;
`;

const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const UserName = styled.p`
  ${({ theme }) => theme.typograph.paragraphMedium};
  color: ${({ theme }) => theme.colors.contrastColorBackground};
  text-transform: uppercase;
`;

const UserAccessInfo = styled.p`
  ${({ theme }) => theme.typograph.hintRegular};
  color: ${({ theme }) => theme.colors.contrastColorBackground};
  text-transform: uppercase;
`;

export {
  StyledHeader,
  TitleVersionContainer,
  Title,
  Version,
  UserInfoContainer,
  UserName,
  UserAccessInfo,
};
